// Package Imports
import { queryOptions } from '@tanstack/react-query'

// Module Imports
import { getLobbyList, getLobbyDetail } from '@/modules/lobby/lobby.service'
import type { TLobbyListQuery } from '@/modules/lobby/lobby.types'

// Query Options
export const lobbyListQueryOptions = (query?: Partial<TLobbyListQuery>) => {
  const defaultQuery: TLobbyListQuery = {
    page: query?.page ?? 1,
    per_page: query?.per_page ?? 10,
    ...(query?.q && { q: query.q }),
  }

  return queryOptions({
    queryKey: ['lobbies', 'list', defaultQuery],
    queryFn: async () => getLobbyList(defaultQuery),
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const lobbyDetailQueryOptions = (lobbyId: string) => {
  return queryOptions({
    queryKey: ['lobbies', 'detail', lobbyId],
    queryFn: async () => getLobbyDetail(lobbyId),
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
